import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import BallotIcon from "@mui/icons-material/Ballot";
import GridViewIcon from "@mui/icons-material/GridOn";
import MonitorIcon from "@mui/icons-material/Dvr";
import StoreIcon from "@mui/icons-material/Store";
import MailIcon from "@mui/icons-material/Mail";
import UserIcon from "@mui/icons-material/PeopleAlt";
import RoomPreferencesOutlinedIcon from "@mui/icons-material/RoomPreferencesOutlined";
import lngs from "../../lngs";
import DomainAddIcon from '@mui/icons-material/DomainAdd';

const NavBar = ({ openDrower }) => {
  const location = useLocation();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const { t, i18n } = useTranslation();
  const currentLang = i18n.resolvedLanguage;
  const isLanguageRTL = lngs[i18n.resolvedLanguage]?.isRtl || false;
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  if (!user) return null;

  return (
    <div className="np">
      <nav
        className={["navbar", openDrower ? "navbarOpend" : ""].join(" ")}
        open={true}
        style={isLanguageRTL ? { right: 0 } : { left: 0 }}
      >
        <ul className="navbar-nav">
          <li className="logo">
            <Link to={`/${currentLang}/app/main`} className="nav-link">
              <span className="link-text logo-text">
                <img
                  style={{ width: "100px", paddingTop: "15px", height: "80px" }}
                  src="/logo.svg"
                  alt="quantum-invoice"
                />
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-arrow-right"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </Link>
          </li>
          <li className="nav-item">
            <Link to={`/${currentLang}/app/main`} className="nav-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-home"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
              <span className="link-text">{t("Home")}</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to={`/${currentLang}/app/dashboard`} className="nav-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-pie-chart"
              >
                <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
              </svg>
              <span className="link-text">{t("Dashboard")}</span>
            </Link>
          </li>

          <li className="nav-item">
            <Link to={`/${currentLang}/app/accounting`} className="nav-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-layers"
              >
                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                <polyline points="2 17 12 22 22 17"></polyline>
                <polyline points="2 12 12 17 22 12"></polyline>
              </svg>
              <span className="link-text">{t("Accounting")}</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to={`/${currentLang}/app/customers`} className="nav-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-users"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <span className="link-text">{t("Customers")}</span>
            </Link>
          </li>

          <li className="nav-item" id="themeButton">
            <Link
              to={`/${currentLang}/app/admin-settings`}
              className="nav-link"
            >
              <RoomPreferencesOutlinedIcon
                style={{ width: "24px", height: "24px" }}
              />
              <span className="link-text">{t("Admin Settings")}</span>
            </Link>
          </li>

          <li className="nav-item" id="themeButton">
            <Link to={`/${currentLang}/app/letters/home`} className="nav-link">
              <MailIcon />
              <span className="link-text">{t("Letters")} </span>
            </Link>
          </li>
          <li className="nav-item" id="themeButton">
            <Link to={`/${currentLang}/app/rentals/home`} className="nav-link">
              <UserIcon />
              <span className="link-text">{t("Rentals")} </span>
            </Link>
          </li>
          <li className="nav-item" id="themeButton">
            <Link to={`/${currentLang}/app/property-management`} className="nav-link">
              <DomainAddIcon 
              style={{ width: "24px", height: "24px" }}
              />
              <span className="link-text">{t("Property Management")} </span> 
            </Link>
          </li>
          <li className="nav-item" id="themeButton">
            <Link to={`/${currentLang}/app/settings`} className="nav-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-settings"
              >
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
              <span className="link-text">{t("Settings")}</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default NavBar;
